var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entries)?_c('client-information',{staticClass:"client-info",attrs:{"entries":_vm.entries},on:{"updateCustomerInfo":_vm.updateClientInfo}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }